module.exports = __webpack_public_path__ + "assets/support.8b3d8004.svg";